<template>
  <div>
    <b-form-group>
      <validation-provider
        #default="{ errors }"
        :name="errorName"
        :rules="rules"
        :vid="vid"
      >
        <b-form-checkbox
          v-model="selectedValue"
          checked="false"
          :name="name"
          switch
          inline
          :disabled="readonly"
          @change="onChange"
        >
          {{ label }}
        </b-form-checkbox>
        <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group>
  </div>
</template>

<script>
import { BFormGroup, BFormCheckbox } from 'bootstrap-vue'
import { ValidationProvider } from 'vee-validate'

export default {
  name: 'SwitchButton',
  components: {
    BFormCheckbox,
    BFormGroup,
    ValidationProvider,
  },
  props: {
    label: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    errorName: {
      type: String,
      default: 'default',
    },
    rules: {
      type: [Object, String],
      default: '',
    },
    readonly: {
      type: Boolean,
      required: false,
    },
    value: {
      type: null,
      default: '',
    },
    onChange: {
      type: Function,
      default: () => {},
      required: false,
    },
    vid: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      selectedValue: '',
    }
  },
  computed: {
    hasValue() {
      return !!this.selectedValue
    },
  },
  watch: {
    selectedValue(value) {
      this.$emit('input', value)
    },
    value(val) {
      if (val !== this.selectedValue) {
        this.selectedValue = val
      }
    },
  },
  created() {
    if (this.value) {
      this.selectedValue = this.value
    }
  },
}
</script>
